import { render, staticRenderFns } from "./ChecksInput.vue?vue&type=template&id=da87f3fc&"
import script from "./ChecksInput.vue?vue&type=script&lang=js&"
export * from "./ChecksInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports